import React, {Fragment} from "react";
import {connect} from "react-redux";
import {injectIntl} from "react-intl";
import PropTypes from "prop-types";

import {getBase64ImgOnInputChange} from "../../../utilities";
import {errorBox_Show} from "../../../actions/A_Popups";
import {wizardItemInterface} from "./wizardItemInterface";
import {updateWizardList} from "../wizardActions";

const WizardItemThumbnail = (props) => {

  const {intl, errorBox_Show, wizardItem, updateWizardList, imageOnly} = props;
  const {uploadedImageUrl, customImageUrl} = wizardItem;

  const onImageLoad = (e) => {
    wizardItem.uploadedImageUrl = e.target.result;
    updateWizardList(wizardItem);
  };

  const handleUploadChange = (event) => {
    getBase64ImgOnInputChange(event, onImageLoad, errorBox_Show, intl)
  };

  return (
    <Fragment>
      <label className={"wizard-item__thumbnail" + (imageOnly ? " wizard-item__thumbnail--image-only" : "")}
             htmlFor={"wizard-item__thumbnail-" + wizardItem.uniqueHashId}
             style={uploadedImageUrl || customImageUrl
               ? {backgroundImage: `url(${uploadedImageUrl || customImageUrl})`}
               : null}>
      </label>
      <input id={"wizard-item__thumbnail-" + wizardItem.uniqueHashId}
             type="file"
             className="wizard-upload__input"
             accept="image/png, image/jpeg, image/svg"
             onChange={imageOnly ? null : handleUploadChange}/>
    </Fragment>
  )
};

WizardItemThumbnail.propTypes = {
  wizardItem: PropTypes.shape(wizardItemInterface),
  imageOnly: PropTypes.bool,
}

const mapStateToProps = () => {
  // const {wizardPopupGroup} = store.wizardState;
  return {
    // wizardPopupGroup,
  };
};

const mapDispatchToProps = {
  errorBox_Show,
  updateWizardList
};

export default injectIntl(
  connect(mapStateToProps, mapDispatchToProps)(WizardItemThumbnail)
)
